import "./footer.css";
import logo from "../../assets/images/logo/Logo_Carpe_Diem.png";
import { Link, useLocation } from "react-router-dom";
import AnimatedScrollFooter from "../AnimatedScrollFooter/AnimatedScrollFooter";
import { getImage } from "../../config/imageConfig";

const Footer = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const footerLogo = getImage("footer.logo") || logo;
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer>
        <div className="Wrapper-sc">
          <div id="comp-178f4517dab" className="comp"></div>
          <div id="comp-6" className="comp"></div>
          <div className="Container-sc FootCont">
            <div className="WMContainer-sc">
              <AnimatedScrollFooter>
                <div className="LinkContainer-sc">
                  <div className="Wrap-sc">
                    <div className="link-wrapper ">
                      <Link
                        id="header_link_0"
                        className={`linkNav${isActive("/") ? " active" : ""}`}
                        to="/"
                      >
                        Accueil
                      </Link>
                    </div>
                  </div>
                  <div className="Wrap-sc">
                    <div className="link-wrapper ">
                      <Link
                        id="header_link_1"
                        className={`linkNav${
                          isActive("/menu") ? " active" : ""
                        }`}
                        to="/menu"
                      >
                        Menu
                      </Link>
                    </div>
                  </div>
                  <div className="Wrap-sc">
                    <div className="link-wrapper ">
                      <Link
                        id="header_link_2"
                        className={`linkNav${
                          isActive("/notre-restaurant") ? " active" : ""
                        }`}
                        to="/notre-restaurant"
                      >
                        Notre Restaurant
                      </Link>
                    </div>
                  </div>
                  <div className="Wrap-sc">
                    <div className="link-wrapper ">
                      <Link
                        id="header_link_2b"
                        className={`linkNav${
                          isActive("/nos-chambres") ? " active" : ""
                        }`}
                        to="/nos-chambres"
                      >
                        Nos Chambres
                      </Link>
                    </div>
                  </div>
                  <div className="Wrap-sc">
                    <div className="link-wrapper ">
                      <Link
                        id="header_link_4"
                        className={`linkNav${
                          isActive("/contact") ? " active" : ""
                        }`}
                        to="/contact"
                      >
                        Contact
                      </Link>
                    </div>
                  </div>
                  <div className="Wrap-sc">
                    <div className="link-wrapper ">
                      <Link
                        id="header_link_5"
                        className={`linkNav${
                          isActive("/tourisme") ? " active" : ""
                        }`}
                        to="/tourisme"
                      >
                        Tourisme
                      </Link>
                    </div>
                  </div>
                </div>
              </AnimatedScrollFooter>
              <AnimatedScrollFooter>
                <div className="FooterContentWrap-sc">
                  <div className="FooterContent-sc">
                    <div className="logo-wrapper Figure-sc">
                      <figure className="Footer-Figure">
                        <img
                          width="100.23436450958252"
                          className=" logo-Footer img-loaded StyledImg-sc"
                          alt="Footer logo"
                          sizes="[object Object]"
                          src={footerLogo}
                        />
                      </figure>
                      <div className="image-state-overlay StateOverlay-sc">
                        <div className="Content-sc"></div>
                      </div>
                    </div>
                    <div className="allDroit">
                      <a
                        className="textFooter"
                        href="https://www.devalls.fr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        © {currentYear} Dev'alls, Tous droits réservés.
                      </a>
                      <Link
                        className="linkContact mentionlegal"
                        to="/legalnotices"
                      >
                        Mentions légal
                      </Link>
                    </div>
                  </div>
                  <div className="socials-block SocialsBlock-sc">
                    <div className="socials-wrapper SocialsWrapper-sc">
                      <div className="link-wrapper">
                        <a
                          aria-label="Social link"
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.facebook.com/p/CARPE-DIEM-12-61577135145308/"
                        >
                          <div
                            data-name="icon-facebook"
                            className="Footer-SvgIcon-sc"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                            >
                              <path d="M12.026 6.81v4.13H9v5.051h3.026V31h6.216V15.992h4.171s.391-2.422.58-5.07h-4.728V7.469c0-.516.678-1.21 1.348-1.21H23V1.001h-4.605c-6.523 0-6.369 5.055-6.369 5.81z"></path>
                            </svg>
                          </div>
                        </a>
                      </div>

                      <div className="link-wrapper">
                        <a
                          aria-label="Social link"
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.instagram.com/carpediem_goutrens/"
                        >
                          <div
                            data-name="icon-instagram"
                            className="Footer-SvgIcon-sc"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                            >
                              <path d="M16 8.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 12.188A4.695 4.695 0 0111.312 16c0-2.586 2.104-4.688 4.688-4.688s4.688 2.102 4.688 4.688A4.695 4.695 0 0116 20.688zm8.063-11.751a.999.999 0 110-1.997.999.999 0 010 1.997zM21.625 1h-11.25A9.376 9.376 0 001 10.375v11.25A9.376 9.376 0 0010.375 31h11.25A9.376 9.376 0 0031 21.625v-11.25A9.376 9.376 0 0021.625 1zm6.563 20.625a6.57 6.57 0 01-6.563 6.563h-11.25a6.57 6.57 0 01-6.563-6.563v-11.25a6.57 6.57 0 016.563-6.563h11.25a6.57 6.57 0 016.563 6.563v11.25z"></path>
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </AnimatedScrollFooter>
            </div>
          </div>
        </div>
      </footer>
      <div className="Footer-sc"></div>
    </>
  );
};

export default Footer;
